import { Button } from 'antd';
import { useState } from 'react';
import { BaseKey } from '@refinedev/core';
import { fetcher } from '../../utils/fetcher';

type Props = {
  userId?: BaseKey;
};

export const SkipEmailVerifyButton = ({ userId }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const verify = async () => {
    setIsLoading(true);
    await fetcher(`/admin/users/${userId}/skip_email_verify`, { method: 'POST' });
    setIsLoading(false);
  };

  return (
    <Button onClick={verify} loading={!userId || isLoading}>
      認証スキップ
    </Button>
  );
};
